/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type KillswitchesListMCPServersSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesListMCPServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type KillswitchesListMCPServersSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesListMCPServersSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesListMCPServersSecurity$Outbound,
  KillswitchesListMCPServersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesListMCPServersSecurityToJSON(
  killswitchesListMCPServersSecurity: KillswitchesListMCPServersSecurity,
): string {
  return JSON.stringify(
    KillswitchesListMCPServersSecurity$outboundSchema.parse(
      killswitchesListMCPServersSecurity,
    ),
  );
}

/** @internal */
export type KillswitchesListMCPServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const KillswitchesListMCPServersRequest$outboundSchema: z.ZodMiniType<
  KillswitchesListMCPServersRequest$Outbound,
  KillswitchesListMCPServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function killswitchesListMCPServersRequestToJSON(
  killswitchesListMCPServersRequest: KillswitchesListMCPServersRequest,
): string {
  return JSON.stringify(
    KillswitchesListMCPServersRequest$outboundSchema.parse(
      killswitchesListMCPServersRequest,
    ),
  );
}
